import { Organization } from './organisation';
import { App, StatementDisplayMode } from './static';
import { SupportedLanguages } from './utils';

export const pdfExportLimit = 450;

export interface PdfParamsFilters {
  avails?: string,
  availsFormValue?: string,
  contentType?: string,
  genres?: string,
  originCountries?: string,
}

export interface PdfParams {
  titleIds: string[],
  app: App,
  orgId?: string,
  filters: PdfParamsFilters
}

export interface PdfRequest {
  method: string,
  body: PdfParams
}

/**
 * Per-statement PDF preference, stored on the statement document next to hiddenData and read by the
 * PDF generation. Declared here rather than on the frozen Statement interface; use it as
 * `Statement & StatementPdfPreferences`. Absent or false means detached, which is the default.
 */
export interface StatementPdfPreferences {
  /** When true, the incoming (distributor / direct sales) statements are appended to the outgoing PDF. */
  attachIncomingStatements?: boolean;
}

export interface StatementPdfParams {
  waterfallId: string;
  statementId: string;
  number: number;
  versionId: string;
  fileName?: string;
  org?: Organization;
  lang?: SupportedLanguages;
  displayMode: StatementDisplayMode;
  /**
   * The organisation of whoever asks for the PDF, when it represents the statement's sender: its address
   * and logo then go on the front page and in the "From" block, should several organisations represent
   * that rights holder (a title created by one organisation and shared with the producer's own). The name
   * printed stays the rights holder's. See getIssuer.
   */
  issuerOrgId?: string;
}

export interface StatementPdfRequest {
  method: string,
  body: StatementPdfParams
}